var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "usersSelectDialog" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(" " + _vm._s(_vm.$t("userselection.add-learners")) + " ")
          ]),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: _vm.$t("global.search"),
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              "item-key": "id",
              loading: _vm.loading,
              search: _vm.search,
              "sort-by": ["displayName"],
              "sort-desc": [false],
              "show-select": ""
            },
            scopedSlots: _vm._u([
              {
                key: "item.displayName",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.displayName) + " ")]
                }
              },
              {
                key: "item.tag",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.tag) + " ")]
                }
              }
            ]),
            model: {
              value: _vm.selection,
              callback: function($$v) {
                _vm.selection = $$v
              },
              expression: "selection"
            }
          }),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: !_vm.selection.length > 0,
                    color: "success"
                  },
                  on: { click: _vm.validate }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.continue")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }